export const Types = {
    GET_TASKS_LIST_FOR_PLANNED_MAINTENANCE_LIST: "GET_TASKS_LIST_FOR_PLANNED_MAINTENANCE_LIST",
    GET_PLANNED_MAINTENANCE_MULTIPLE: "GET_PLANNED_MAINTENANCE_MULTIPLE",
    GET_EXCEL_FILE: "GET_EXCEL_FILE",
    GET_POOL_LIST_FOR_PLANNED_MAINTENANCE_LIST: "GET_POOL_LIST_FOR_PLANNED_MAINTENANCE_LIST",
    GET_STATUS_LIST_FOR_PLANNED_MAINTENANCE_LIST: " GET_STATUS_LIST_FOR_PLANNED_MAINTENANCE_LIST",
    GET_UNPLANNED_MAINTATENANCE_LIST_FOR_LIST: " GET_UNPLANNED_MAINTATENANCE_LIST_FOR_LIST",
    GET_PLANNED_MAINTATENANCE_LIST_FOR_LIST: " GET_PLANNED_MAINTATENANCE_LIST_FOR_LIST",
    GET_TECHNICIAN_LIST_FOR_PLANNED_MAINTENANCE_LIST: "GET_TECHNICIAN_FOR_PLANNED_MAINTENANCE_LIST",
    GET_COST_CENTER_LIST_FOR_PLANNED_MAINTENANCE_LIST: "GET_COST_CENTER_LIST_FOR_PLANNED_MAINTENANCE_LIST",
    GET_AREA_LIST_FOR_PLANNED_MAINTENANCE_LIST: "GET_AREA_LIST_FOR_PLANNED_MAINTENANCE_LIST",
    GET_MAIN_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST: "GET_MAIN_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST",
    GET_SUB_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST: "GET_SUB_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST",
    GET_MAINTENANCE_TYPE_LIST: "GET_MAINTENANCE_TYPE_LIST",

    SET_TASKS_LIST_FOR_PLANNED_MAINTENANCE_LIST: " SET_TASKS_LIST_FOR_PLANNED_MAINTENANCE_LIST",
    SET_PLANNED_MAINTENANCE_MULTIPLE: "SET_PLANNED_MAINTENANCE_MULTIPLE",
    SET_POOL_LIST_FOR_PLANNED_MAINTENANCE_LIST: " SET_POOL_LIST_FOR_PLANNED_MAINTENANCE_LIST",
    SET_STATUS_LIST_FOR_PLANNED_MAINTENANCE_LIST: " SET_STATUS_LIST_FOR_PLANNED_MAINTENANCE_LIST",
    SET_PLANNED_MAINTATENANCE_LIST: " SET_PLANNED_MAINTATENANCE_LIST",
    SET_TECHNICIAN_LIST_FOR_PLANNED_MAINTENANCE_LIST: "SET_TECHNICIAN_LIST_FOR_PLANNED_MAINTENANCE_LIST",
    SET_COST_CENTER_LIST_FOR_PLANNED_MAINTENANCE_LIST: "SET_COST_CENTER_LIST_FOR_PLANNED_MAINTENANCE_LIST",
    SET_AREA_LIST_FOR_PLANNED_MAINTENANCE_LIST: "SET_AREA_LIST_FOR_PLANNED_MAINTENANCE_LIST",
    SET_MAIN_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST: "SET_MAIN_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST",
    SET_SUB_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST: "SET_SUB_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST",
    SET_MAINTENANCE_TYPE_LIST: "SET_MAINTENANCE_TYPE_LIST",

    RESET_TASKS_LIST_FOR_PLANNED_MAINTENANCE_LIST: "RESET_TASKS_LIST_FOR_PLANNED_MAINTENANCE_LIST",
    RESET_POOL_LIST_FOR_PLANNED_MAINTENANCE_LIST: "RESET_POOL_LIST_FOR_PLANNED_MAINTENANCE_LIST",
    RESET_STATUS_LIST_FOR_PLANNED_MAINTENANCE_LIST: "RESET_STATUS_LIST_FOR_PLANNED_MAINTENANCE_LIST",
    RESET_PLANNED_MAINTATENANCE_LIST: "RESET_PLANNED_MAINTATENANCE_LIST",
    RESET_TECHNICIAN_LIST_FOR_PLANNED_MAINTENANCE_LIST: "RESET_TECHNICIAN_LIST_FOR_PLANNED_MAINTENANCE_LIST",
    RESET_COST_CENTER_LIST_FOR_PLANNED_MAINTENANCE_LIST: "RESET_COST_CENTER_LIST_FOR_PLANNED_MAINTENANCE_LIST",
    RESET_AREA_LIST_FOR_PLANNED_MAINTENANCE_LIST: "RESET_AREA_LIST_FOR_PLANNED_MAINTENANCE_LIST",
    RESET_MAIN_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST: "RESET_MAIN_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST",
    RESET_SUB_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST: "RESET_SUB_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST",

    CLOSE_MANY_PLANNED_TASKS: "CLOSE_MANY_PLANNED_TASKS",
    IS_UPDATED_TASK_PLANNED: "IS_UPDATED_TASK_PLANNED",
    RESET_IS_UPDATED_TASK: "RESET_IS_UPDATED_TASK",

    GET_POOL_LIST_BY_ASSIGNED_USER: "GET_POOL_LIST_BY_ASSIGNED_USER",
    SET_POOL_LIST_BY_ASSIGNED_USER: "SET_POOL_LIST_BY_ASSIGNED_USER",
};

export const getTaskList = (payload) => ({
    type: Types.GET_TASKS_LIST_FOR_PLANNED_MAINTENANCE_LIST,
    payload,
});

export const getList = () => ({
    type: Types.GET_POOL_LIST_FOR_PLANNED_MAINTENANCE_LIST,
});

export const getPlannedMaintenanceListMultiple = (payload) => ({
    type: Types.GET_PLANNED_MAINTENANCE_MULTIPLE,
    payload: payload,
});

export const downloadExcelFile = (payload) => ({
    type: Types.GET_EXCEL_FILE,
    payload,
});

export const setPlannedMaintenanceListMultiple = (payload) => ({
    type: Types.SET_PLANNED_MAINTENANCE_MULTIPLE,
    payload: payload,
});

export const getStatusList = () => ({
    type: Types.GET_STATUS_LIST_FOR_PLANNED_MAINTENANCE_LIST,
});

export const getplannedMaintenance = (payload) => ({
    type: Types.GET_PLANNED_MAINTATENANCE_LIST_FOR_LIST,
    payload,
});
export const getTechnicianList = (payload) => ({
    type: Types.GET_TECHNICIAN_LIST_FOR_PLANNED_MAINTENANCE_LIST,
    payload,
});
export const getCostCenterList = (payload) => ({
    type: Types.GET_COST_CENTER_LIST_FOR_PLANNED_MAINTENANCE_LIST,
    payload,
});
export const getAreaList = () => ({
    type: Types.GET_AREA_LIST_FOR_PLANNED_MAINTENANCE_LIST,
});
export const getMainListByAreaID = (payload) => ({
    type: Types.GET_MAIN_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST,
    payload,
});

export const getSubListById = (payload) => ({
    type: Types.GET_SUB_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST,
    payload,
});

export const getMaintenanceTypeList = (payload) => ({
    type: Types.GET_MAINTENANCE_TYPE_LIST,
    payload,
});

// ------------ set actions ------------------------//

export const setTaskList = (payload) => ({
    type: Types.SET_TASKS_LIST_FOR_PLANNED_MAINTENANCE_LIST,
    payload: payload,
});

export const setList = (payload) => ({
    type: Types.SET_POOL_LIST_FOR_PLANNED_MAINTENANCE_LIST,
    payload,
});

export const setStatusList = (payload) => ({
    type: Types.SET_STATUS_LIST_FOR_PLANNED_MAINTENANCE_LIST,
    payload,
});

export const setUnplannedMaintenance = (payload) => ({
    type: Types.SET_UNPLANNED_MAINTATENANCE_LIST,
    payload,
});

export const setplannedMaintenance = (payload) => ({
    type: Types.SET_PLANNED_MAINTATENANCE_LIST,
    payload,
});
export const setTechnicianList = (payload) => ({
    type: Types.SET_TECHNICIAN_LIST_FOR_PLANNED_MAINTENANCE_LIST,
    payload,
});
export const setCostCenterList = (payload) => ({
    type: Types.SET_COST_CENTER_LIST_FOR_PLANNED_MAINTENANCE_LIST,
    payload,
});
export const setAreaList = (payload) => ({
    type: Types.SET_AREA_LIST_FOR_PLANNED_MAINTENANCE_LIST,
    payload,
});
export const setMainListByAreaID = (payload) => ({
    type: Types.SET_MAIN_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST,
    payload,
});

export const setSubListById = (payload) => ({
    type: Types.SET_SUB_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST,
    payload,
});

export const setMaintenanceTypeList = (payload) => ({
    type: Types.SET_MAINTENANCE_TYPE_LIST,
    payload,
});

// ------------ Reset actions ------------------------//

export const resetTaskList = () => ({
    type: Types.RESET_TASKS_LIST_FOR_PLANNED_MAINTENANCE_LIST,
});

export const resetList = () => ({
    type: Types.RESET_POOL_LIST_FOR_PLANNED_MAINTENANCE_LIST,
});

export const resetStatusList = () => ({
    type: Types.RESET_STATUS_LIST_FOR_PLANNED_MAINTENANCE_LIST,
});

export const resetUnplannedMaintenance = () => ({
    type: Types.RESET_UNPLANNED_MAINTATENANCE_LIST,
});

export const resetplannedMaintenance = () => ({
    type: Types.RESET_PLANNED_MAINTATENANCE_LIST,
});
export const resetTechnicianList = () => ({
    type: Types.RESET_TECHNICIAN_LIST_FOR_PLANNED_MAINTENANCE_LIST,
});
export const resetCostCenterList = () => ({
    type: Types.RESET_COST_CENTER_LIST_FOR_PLANNED_MAINTENANCE_LIST,
});
export const resetAreaList = () => ({
    type: Types.RESET_AREA_LIST_FOR_PLANNED_MAINTENANCE_LIST,
});
export const resetMainListByAreaID = () => ({
    type: Types.RESET_MAIN_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST,
});

export const resetSubListById = () => ({
    type: Types.RESET_SUB_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST,
});

export const closeManyPlannedTasks = (payload) => ({
    type: Types.CLOSE_MANY_PLANNED_TASKS,
    payload,
});

export const isUpdateTask = (payload) => ({
    type: Types.IS_UPDATED_TASK_PLANNED,
    payload,
});

export const resetIsUpdateTask = (payload) => ({
    type: Types.RESET_IS_UPDATED_TASK,
    payload,
});

export const getPoolByAssignedUser = () => ({
    type: Types.GET_POOL_LIST_BY_ASSIGNED_USER,
});

export const setPoolByAssignedUser = (payload) => ({
    type: Types.SET_POOL_LIST_BY_ASSIGNED_USER,
    payload,
});